import {EventEmitter, Injectable} from '@angular/core';
import {IGuideObject, IGuideStep} from '@models/user-guide.model';

const USER_GUIDES_KEY = 'ls-user-guide-shown';

@Injectable({
  providedIn: 'root'
})
export class UserGuideService {
  guides: {
    [key: string]: IGuideStep[]
  } = {};
  activeGuide: EventEmitter<IGuideObject> = new EventEmitter<IGuideObject>();
  changeStep: EventEmitter<number> = new EventEmitter<number>();
  guideUpdated: EventEmitter<IGuideObject> = new EventEmitter<IGuideObject>();

  runNext: string;
  currentGuide: string;

  constructor() {
  }

  setRunNext(runNext: string) {
    if (this.currentGuide) {
      this.runNext = runNext;
    }
  }

  /**
   * Registers user guide with specified id
   * @param guide guide object to register
   */
  register(guide: IGuideObject) {
    const {guideId, steps} = guide;
    if (guideId in this.guides) {
      const stepsToAdd = this.guides[guideId].filter(
          (step) => !steps.find((item) => item.step === step.step));
      this.guides[guideId] = [...stepsToAdd, ...steps].sort((item, item2) => {
        return item.step > item2.step ? 1 : -1;
      });
      this.guideUpdated.emit({guideId, steps: this.guides[guideId]});
    } else {
      this.guides[guideId] = steps;
    }
  }

  /**
   * Starts user guide
   */
  showGuide(id: string) {
    if (!(id in this.guides)) {
      throw Error(`Guide ${id} is not registered!`);
    }
    this.runNext = null;
    this.currentGuide = id;
    this.activeGuide.emit({guideId: id, steps: this.guides[id]} as IGuideObject);
  }

  /**
   * Hides current guide
   */
  hideGuide() {
    this.runNext = null;
    this.currentGuide = null;
    this.activeGuide.emit(null);
  }

  /**
   * Runs guide step by index
   * @param stepIdx
   */
  initStep(stepIdx) {
    this.changeStep.emit(stepIdx);
  }
}
